import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { analytics, EVENT_NAMES } from 'services/Analytics/Analytics'
import SessionStorageManager from 'services/SessionStorageManager'
import * as S from './CanadaTariffNotice.styles'

const TARIFF_NOTICE_DISMISSED_STORAGE_KEY = 'canada-tariff-notice-dismissed'

type CanadaTariffNoticeProps = {
  messageKey: string
  isDismissible?: boolean
}

export default function CanadaTariffNotice({
  messageKey,
  isDismissible = false,
}: CanadaTariffNoticeProps) {
  const { t } = useTranslation()
  const [isDismissed, setIsDismissed] = useState(
    () =>
      isDismissible &&
      SessionStorageManager.get(TARIFF_NOTICE_DISMISSED_STORAGE_KEY) === true
  )

  const onDismissClick = () => {
    setIsDismissed(true)
    SessionStorageManager.set(TARIFF_NOTICE_DISMISSED_STORAGE_KEY, true)
    analytics.track(EVENT_NAMES.CANADA_TARIFF_NOTICE_DISMISSED)
  }

  if (isDismissed) {
    return null
  }

  return (
    <S.Notice data-testid="canada-tariff-notice">
      <S.Message>
        <S.Coin aria-hidden />
        <span>{t(messageKey)}</span>
      </S.Message>
      {isDismissible && (
        <S.DismissButton
          onClick={onDismissClick}
          data-testid="canada-tariff-notice-dismiss"
        >
          <S.DismissIcon />
        </S.DismissButton>
      )}
    </S.Notice>
  )
}
